module.exports = __webpack_public_path__ + "static/popup_PC@2x-min-64a3e09076039a00889ea2ea3ab965d9.png";